import Buypoint from '@/pages/Buypoint'

// export default {
//   path: '/buypoint',
//   name: 'Buypoint',
//   component: Buypoint,
  
// }

export default {
    path: '/buypoint',
    component: Buypoint,
    children: [
      {
        path: '',
        name: 'Buypoint',
        component: Buypoint
      },
      {
        path: '/shoptogether',
        name: 'ShopTogether',
        component: Buypoint,
      },
      {
        path: '/shoptogether/:ref',
        name: 'ShopTogetherRefLink',
        component: Buypoint,
      }
    ]
}



// WEBPACK FOOTER //
// ./src/router/buypoint.js